import React from 'react'
import Link from 'gatsby-link'

const IndexPage = ({ data , transition }) => (
  <div style={transition && transition.style}>
  <div className="home_page_top">
  <div className="home_intro">
    <h1 className="pages_head">I am</h1>
    <p>a <span className="highlight_about">Developer</span> and <span className="highlight_about">Designer</span> with more than <span className="highlight_about">12 years experience</span> creating and maintaining websites, HTML email campaigns, print publications, general print collateral, branding assets and analytics that support the business goals of organizations that I’ve served with, founded and worked for.
      </p>
    </div>
    <div className="home_write_list">  
    <h2>Recent Posts</h2>
    <ul>
    {data.allMarkdownRemark.edges.map(post => (
      <li key={post.node.id}><Link to={post.node.frontmatter.path}>{post.node.frontmatter.title}</Link></li>
    ))}
    </ul>
    </div>
  </div>
  <div className="home_page_bottom">
  <div className="home_learning_list">
  <h2>Currently Learning More About</h2>
    <ul>
    {data.allLearningnowJson.edges.map(learning => (
      <li key={learning.node.id}><a target="_blank" rel="nofollow noopener" href={learning.node.url}>{learning.node.name}</a></li>
    ))}
    </ul>
  </div>
  </div>
  </div>
)

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 10
      sort: {fields: [frontmatter___date], order: DESC }
      filter: {frontmatter: {pub: {eq: true}} }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            path
            author
          }
        }
      }
    }
    allLearningnowJson{
      edges {
        node {
          id
          name
          url
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js